import React, { useState, useEffect } from "react";
import { FaInfoCircle, FaRegClock } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import HireAIExpertModal from "../Modals/HireAIExpertModal/HireAIExpertModal";
import SucceesModal from "../whatsappBot/SucceesModal";
import ApplyForJobModal from "../Modals/ApplyForJobModal";
import ReactGA from "react-ga4";
import axios from "axios";

const Info = () => {
  const { t } = useTranslation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUsingEmailForm, setIsUsingEmailForm] = useState(false);
  const [currentCategory, setCurrentCategory] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  const [formStatus, setFormStatus] = useState({
    isLoading: false,
    isSuccess: false,
    error: null,
  });

  const getDefaultZoomLevel = () => (window.innerWidth <= 767 ? 1 : 2);
  const [zoomLevel, setZoomLevel] = useState(getDefaultZoomLevel());
  const [iframeKey, setIframeKey] = useState(Date.now());

  const updateZoomLevel = () => {
    setZoomLevel(getDefaultZoomLevel());
    setIframeKey(Date.now());
  };

  useEffect(() => {
    window.addEventListener("resize", updateZoomLevel);
    return () => window.removeEventListener("resize", updateZoomLevel);
  }, []);

  useEffect(() => {
    if (formStatus.error) {
      const timer = setTimeout(
        () => setFormStatus((prev) => ({ ...prev, error: null })),
        3000
      );
      return () => clearTimeout(timer);
    }
  }, [formStatus]);

  const handleSuccess = () => setIsSuccessModalVisible(true);
  const handleCloseSuccessModal = () => setIsSuccessModalVisible(false);

  const resetForm = () => {
    setIsModalVisible(false);
    setErrorMessage(null);
    setIsUsingEmailForm(false);
    setPhoneNumber("");
    setEmail("");
    setFormStatus({ isLoading: false, isSuccess: false, error: null });
  };

  const submitForm = async (data, isEmail = false) => {
    const url = isEmail
      ? `${process.env.REACT_APP_APIURL}contact`
      : `${process.env.REACT_APP_WHATSAPP_API_CALL}send`;

    const payload = {
      ...data,
      category: currentCategory,
    };

    const config = isEmail
      ? { headers: { "Content-Type": "application/json" } }
      : undefined;

    try {
      setFormStatus((prev) => ({ ...prev, isLoading: true }));
      await axios.post(url, payload, config);
      setFormStatus({ isLoading: false, isSuccess: true });
      resetForm();
      handleSuccess();
    } catch {
      setFormStatus({ isLoading: false, error: "Something went wrong!" });
    }
  };

  const handleInquiryClick = (category, path, eventLabel) => {
    window.history.pushState({}, "", path);
    ReactGA.event({
      category: eventLabel,
      action: eventLabel,
      label: eventLabel,
      value: 1,
    });
    setCurrentCategory(category);
    setIsModalVisible(true);
  };

  const iframeSrc = `https://www.google.com/maps/d/embed?mid=1qVPcFGQ-6MqX6lSi1guZthWXLIvR_ME&hl=en&ehbc=2E312F&z=${zoomLevel}`;

  const buttonStyles = {
    marginTop: "1rem",
    backgroundColor: "#fff",
    color: "#5928d1",
    border: "1px solid #ccc",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
  };

  const isCompactScreen =
    typeof window !== "undefined" && window.innerWidth <= 1024;

  const isVerySmallScreen =
    typeof window !== "undefined" && window.innerWidth <= 425;

  const inquiryTitleStyle = {
    fontSize: "18px",
    fontWeight: 700,
    paddingBottom: "6px",
    borderBottom: "0.75px solid rgba(255, 255, 255, 0.35)",
    letterSpacing: "0.2px",
  };

  const inquiryTitleAccentStyles = {
    collaborate: {
      borderBottom: "2px solid rgba(255, 255, 255, 0.85)",
    },
    career: {
      borderBottom: "2px solid rgba(255, 255, 255, 0.55)",
    },
  };

  return (
    <section id="contact" className="p-0">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 p-0">
            <div className="address-box title mb-0">
              <div className="bg-overlay gradient-bg1 opacity-8" />
              <div className="address-text text-center text-white position-relative">
                <h2 className="mb-2">fxis.ai</h2>
                <h5 className="mb-4">{t("info.tagline")}</h5>

                <div className="d-flex justify-content-center mt-5 px-4 address-location-container" style={{ gap: "40px" }}>
                  {[
                    t("info.usadd1") + t("info.usadd2"),
                    t("info.indadd1") + t("info.indadd2"),
                  ].map((address, idx) => (
                    <div
                      key={idx}
                      // style={{ width: idx === 0 ? "35%" : "40%" }}
                      className="d-flex align-items-center address-location-elm"
                    >
                      <FaLocationDot size="39" />
                      <p
                        className="mb-0 text-white info-add"
                        style={{ textAlign: "left", margin: "0 0 0 15px"}}
                      >
                        {address}
                      </p>
                    </div>
                  ))}
                </div>

                <div
                  className="d-flex justify-content-center address-inquiry-container"
                  style={{ gap: "110px", margin: "8px", marginTop: "41px" }}
                >
                  {[
                    {
                      title: t("info.business"),
                      email: "contact@fxis.ai",
                      phone: "(+91) 97279 99595",
                      buttonLabel: "Business Inquiry",
                      category: "collaborate",
                      path: "/hire-ai-experts",
                      eventLabel: "hire_ai_exports_hero_click",
                    },
                    {
                      title: t("info.career"),
                      email: "career@fxis.ai",
                      phone: "(+91) 98987 49300",
                      buttonLabel: "Career Inquiry",
                      category: "career",
                      path: "#",
                      eventLabel: "apply_for_job_hero_click",
                    },
                  ].map((info, idx) => (
                    <div
                      key={idx}
                      className="mb-3 d-flex flex-column align-items-start"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "6px", marginBottom: "6px" }}
                      >
                        <FaInfoCircle size={14} style={{ position: "relative", top: "-4px" }} />
                        <p
                          className="m-0 text-white inquiry"
                          style={{
                            ...inquiryTitleStyle,
                            ...(inquiryTitleAccentStyles[info.category] || {}),
                          }}
                        >
                          {info.title}
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <i className="fa fa-envelope" />
                        <p
                          className="text-white mb-0 inquiry"
                          style={{
                            margin: "0 0 0 1rem",
                            ...(isVerySmallScreen ? { fontSize: "14px" } : {}),
                          }}
                        >
                          {info.email}
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <i className="fa fa-phone-square" />
                        <p
                          className="text-white mb-0 inquiry"
                          style={{
                            margin: "0 0 0 1rem",
                            ...(isVerySmallScreen ? { fontSize: "14px" } : {}),
                          }}
                        >
                          {info.phone}
                        </p>
                      </div>
                      <button
                        style={{
                          ...buttonStyles,
                          ...(isCompactScreen
                            ? { padding: "6px 10px", fontSize: "11px" }
                            : {}),
                        }}
                        onClick={() =>
                          handleInquiryClick(
                            info.category,
                            info.path,
                            info.eventLabel
                          )
                        }
                      >
                        {info.buttonLabel}
                      </button>
                    </div>
                  ))}
                </div>

                <div className="d-flex align-items-center justify-content-center" style={{marginBottom: "10px", marginTop:"25px"}}>
                  <FaRegClock size="17"/>
                  <p
                    className="text-white mb-0 inquiry"
                    style={{ margin: "0 0 0 1rem" }}
                  >
                    {t("info.timing")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 p-0">
            <div id="map" className="half-map" style={{ position: "relative" }}>
              <div
                className="map-wrap"
                style={{ width: "100%", height: "110%", overflow: "hidden" }}
              >
                <iframe
                  key={iframeKey}
                  title="map"
                  src={iframeSrc}
                  width="100%"
                  height="103%"
                  frameBorder="0"
                  style={{ border: "none", marginTop: -80 }}
                  loading="lazy"
                />
              </div>
              <button
                onClick={updateZoomLevel}
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  zIndex: 1,
                  ...buttonStyles,
                  padding: "5px 10px",
                }}
              >
                Reset Zoom
              </button>
            </div>
          </div>
        </div>

        {isModalVisible &&
          (currentCategory === "career" ? (
            <ApplyForJobModal
              isModalVisible={isModalVisible}
              resetForm={resetForm}
              formStatus={formStatus}
              isUsingEmailForm={isUsingEmailForm}
              errorMessage={errorMessage}
              setIsUsingEmailForm={setIsUsingEmailForm}
              setErrorMessage={setErrorMessage}
              handleEmailSubmission={(data) => submitForm(data, true)}
              handleWhatsappSubmission={(data) => submitForm(data, false)}
              email={email}
              setEmail={setEmail}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
            />
          ) : (
            <HireAIExpertModal
              isModalVisible={isModalVisible}
              resetForm={resetForm}
              formStatus={formStatus}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              handleEmailSubmission={(data) => submitForm(data, true)}
              handleWhatsappSubmission={(data) => submitForm(data, false)}
              email={email}
              setEmail={setEmail}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
            />
          ))}

        {isSuccessModalVisible && (
          <SucceesModal
            SuccessModalVisible={isSuccessModalVisible}
            onclose={handleCloseSuccessModal}
          />
        )}
      </div>
    </section>
  );
};

export default Info;
